export function formatDateSafe(
  dateValue: any, 
  options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' },
  fallback: string = '-'
): string {
  if (!dateValue) return fallback;
  try {
    if (typeof dateValue?.toDate === 'function') {
      return dateValue.toDate().toLocaleDateString('id-ID', options);
    }
    if (dateValue instanceof Date) {
      return dateValue.toLocaleDateString('id-ID', options);
    }
    if (typeof dateValue === 'number' || typeof dateValue === 'string') {
      const parsed = new Date(dateValue);
      if (!isNaN(parsed.getTime())) {
        return parsed.toLocaleDateString('id-ID', options);
      }
    }
    if (dateValue?.seconds) {
      const parsed = new Date(dateValue.seconds * 1000);
      return parsed.toLocaleDateString('id-ID', options);
    }
  } catch (err) {
    console.warn("formatDateSafe error:", err);
  }
  return fallback;
}

export function toIsoStringSafe(dateValue: any, fallback: string = new Date().toISOString()): string {
  if (!dateValue) return fallback;
  try {
    if (typeof dateValue?.toDate === 'function') {
      return dateValue.toDate().toISOString();
    }
    if (dateValue instanceof Date) {
      return dateValue.toISOString();
    }
    if (typeof dateValue === 'number' || typeof dateValue === 'string') {
      const parsed = new Date(dateValue);
      if (!isNaN(parsed.getTime())) {
        return parsed.toISOString();
      }
    }
  } catch {
    // fallback
  }
  return fallback;
}
